import { Injectable } from '@angular/core';
import { SelectedOffer } from '../../api/models/selected-offer';
import { UserProfile } from '../../api/models/user-profile';
import { GAPCalculator } from './gap-calculator';
import { CookieHelperService } from './cookie-helper.service';
import { VehicleService } from './vehicles/vehicle.service';
import { LoanOffer } from '../../api/models/loan-offer';

@Injectable()
export class SelectedOfferService {
    userProfile: UserProfile;
    fromSelectOffer: boolean;
    buyProgramType = [
        'Basic Offer',
        'Lowest APR',
        'Name Your Payment'
    ];

    constructor(
        private gapCalculator: GAPCalculator,
        private vehicleService: VehicleService,
        private cookieService: CookieHelperService,
    ) { }

    getStoredSelectedOffer (): SelectedOffer {
        const fromSelection = this.cookieService._getCookie('isFromSelectOffer');
        const storedOffer = this.cookieService._getCookie('selectedOffer');

        let selected = storedOffer.selected;
        let PMT = this.gapCalculator.calculatePmt(selected.GAPWaiverAmount, 15, selected.Terms);

        // If has a vehicle selected
        if (!fromSelection) {
            if (storedOffer !== null && storedOffer !== undefined) {
                this.vehicleService.getVehicle().subscribe(vehicle => {
                    selected = Object.assign(storedOffer.selected, vehicle.PaymentInfo);

                    const Terms = vehicle.PaymentInfo.Term;
                    PMT = this.gapCalculator.calculatePmt(selected.GAPWaiverAmount, 15, Terms);
                    return {
                        selected: Object.assign(selected, {
                            PMT,
                            Terms,
                            GAPWaiverAmount: selected.GAPWaiverAmount,
                            IsGapSelected: selected.IsGAPWaiverSelected,
                            ApprovedAmount: vehicle.PaymentInfo.AmountFinanced,
                            MonthlyPayment: selected.MonthlyPayment - parseFloat(PMT),
                            DownPayment: parseFloat(selected.DownPayment.replace(/[^0-9\.]+/g, '')),
                        })
                    };
                }, err => {});
            }
        }
        // If has a vehicle selected

        return {
            selected: Object.assign(selected, {
                PMT,
                IsGapSelected: selected.IsGAPWaiverSelected,
            })
        };
    }

    getSelectedOffer(userProfile, fromSelectOffer = false): SelectedOffer {
        this.userProfile = userProfile;
        this.fromSelectOffer = fromSelectOffer;
        const suffix = String(this.getBuyProgramId());

        const paymentInfo = this.getPaymentInfo();
        let offer = <LoanOffer> {
            InquiryId: '',
            VelocifyId: this.userProfile.velocifyLeadID,
            ApprovalDate: this.userProfile.approvalDate,
            ExpirationDate: this.userProfile.expirationDate,
            DealId: Number(this.userProfile.dealId),
            BuyProgramType: this.getBuyProgramTitle(),
            OfferType: Number(suffix),
            GAPWaiverAmount: Number(this.userProfile['gap' + suffix] || 0),
            Ltv: this.userProfile['ltv' + suffix],
            Rate: this.userProfile['rate' + suffix],
            Gap: this.userProfile['gap' + suffix],
            Esc: this.userProfile['esc' + suffix],
            Esctype: this.userProfile['escType' + suffix],
            IsGapSelected: this.isGapSelected(),
            BuyProgramId: this.getBuyProgramId(),
            BuyProgramIndex: this.getBuyProgramId() - 1,
            MaximumVehicleMiles: this.userProfile[`maximumVehicleMiles${suffix}`],
            MinimumVehicleYear: this.userProfile[`minimumVehicleYear${suffix}`],
        };

        const PMT = this.gapCalculator.calculatePmt(offer.GAPWaiverAmount, 15, paymentInfo.Terms);
        offer = Object.assign(offer, { PMT });
        return {
            selected: Object.assign(offer, paymentInfo)
        };
    }

    private getPaymentInfo() {
        const suffix = String(this.getBuyProgramId());

        if (this.isSaveOffer()) {
            // from last approval amount / save offer in vehicle prequalified
            return {
                ApprovedAmount: Number(this.userProfile.approvedAmountFinance || 0),
                MonthlyPayment: Number(this.userProfile.approvedMonthlyPayment || 0),
                APR: Number(this.userProfile.approvedAPR || 0),
                Terms: Number(this.userProfile.approvedTerm),
                DownPayment: Number(this.userProfile.approvedDownPayment || 0),
                ApprovedAmountText: ''
            };
        }

        // Selected buy program
        return {
            ApprovedAmount: Number(this.userProfile['approvalAmount' + suffix] || 0),
            MonthlyPayment: Number(this.userProfile['monthlyPayment' + suffix] || 0),
            APR: Number(this.userProfile['apr' + suffix] || 0),
            Terms: Number(this.userProfile['term' + suffix]),
            DownPayment: Number(this.userProfile['minimumDownPayment' + suffix] || 0),
            ApprovedAmountText: this.userProfile['ApprovedAmountText' + suffix] || ''
        };
    }

    private isSaveOffer() {
        return (this.userProfile.approvedAmountFinance !== '' || this.userProfile.approvedMonthlyPayment !== '') &&
            this.fromSelectOffer === false;
    }

    private getBuyProgramId() {
        let suffix = 0;
        if (this.userProfile.basicOffer === 'True') {
            suffix = 1;
        } else if (this.userProfile.lowestApr === 'True') {
            suffix = 2;
        } else if (this.userProfile.nameYourPayment === 'True') {
            suffix = 3;
        }
        return suffix;
    }

    private isGapSelected() {
        return (
            this.userProfile.gap1 !== '' ||
            this.userProfile.gap2 !== '' ||
            this.userProfile.gap3 !== ''
        );
    }

    private getBuyProgramTitle() {
        const suffix = String(this.getBuyProgramId());
        if (this.userProfile && this.userProfile.vehicleId !== '') {
            return 'Selected car offer';
        }
        return this.buyProgramType[Number(suffix) - 1];
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/selected-offer.service.ts